import { Theme } from "@mui/material/styles";

// ==============================|| OVERRIDES - INPUT BASE ||============================== //

export default function InputBase(theme: Theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          background: theme.palette.grey[0],
          transition: theme.transitions.create(["border", "outline"], {
            duration: theme.transitions.duration.short,
          }),

          "&::before": {
            border: "none !important",
          },
          "&::after": {
            border: "none !important",
          },

          // Border, padding & radius are only for bare (standard-variant) inputs
          // such as the auth <Input>. OutlinedInput/FilledInput draw their own
          // outline, so scope these out — otherwise they render a doubled border
          // and ~70px-tall fields.
          "&:not(.MuiOutlinedInput-root):not(.MuiFilledInput-root)": {
            padding: "12px 16px",
            borderRadius: "6px",
            border: `1px solid ${theme.palette.grey[300]}`,

            // Error state styles
            "&.Mui-error": {
              border: `1px solid ${theme.palette.error.main}`,
            },

            "&.Mui-focused:not(.Mui-error)": {
              border: `1px solid ${theme.palette.common.focus}`,
              outline: `2px solid #1890FF33`,
            },
          },
        },
        input: {
          fontSize: "16px",
          lineHeight: "22px",
          fontWeight: 400,
          padding: 0,

          // Disable browser autocomplete styling
          "&:-webkit-autofill": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.grey[0]} inset`,
            WebkitTextFillColor: theme.palette.text.primary,
            transition: "background-color 5000s ease-in-out 0s",
          },
          "&:-webkit-autofill:hover": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.grey[0]} inset`,
            WebkitTextFillColor: theme.palette.text.primary,
          },
          "&:-webkit-autofill:focus": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.grey[0]} inset`,
            WebkitTextFillColor: theme.palette.text.primary,
          },
          "&:-webkit-autofill:active": {
            WebkitBoxShadow: `0 0 0 1000px ${theme.palette.grey[0]} inset`,
            WebkitTextFillColor: theme.palette.text.primary,
          },
        },
        sizeSmall: {
          fontSize: "0.75rem",
        },
      },
    },
  };
}
